import { LaboratoryResultTypeModel } from './laboratoryResultTypeModel';
import {FileModel} from '../fileModel';

export class UserLaboratoryResultModel {
    public userLaboratoryResultId: number;
    public userId: number;
    public laboratoryResultDate: string;
    public userLaboratoryResultTypes: Array<LaboratoryResultTypeModel>;
    public fileResults: Array<FileModel>;
}